import { client } from '@api'
import { useQuery } from '@tanstack/solid-query'

export function useState() {
	// 2. createQuery implementation
	const scheduledEventNotifications = useQuery(() => {
		return {
			// Unique key for caching. Including 'params' ensures it refetches when params change.
			queryKey: ['getScheduledEventNotifications'],
			// The function that actually fetches the data
			queryFn: () => client.getScheduledEventNotifications(),
			// Optional: Stale time prevents immediate refetching if the component re-mounts
			staleTime: 1000 * 60 * 5, // 5 minutes
		}
	})

	return {
		// Note: TanStack Query returns an object { data, isLoading, error, etc. }
		// unlike createResource which returns a signal-like resource.
		scheduledEventNotifications,
	}
}
